import { NewToggleFlagSelector } from '../components/inventory/new-toggle-flag-selector.vue';
Vue.component('new-toggle-flag-selector', NewToggleFlagSelector);